// 记录第一个被匹配的菜单
// type , 3: 系统 , 4: 目录 5: 模块 , 1: 菜单 , 2: 按钮

import { ref } from 'vue'

export const firstMenu = ref<any>(null)
export function mapMenusToMenus(reqMenu: any[]) {
  const newMenus: any[] = []
  function recurve(list: any[], newItemChild?: any[]) {
    for (const item of list) {
      if (item.type != 3) {
        const resetItem = resetMenuItem(item)
        if (newItemChild) {
          newItemChild.push(resetItem)
        } else {
          newMenus.push(resetItem)
        }

        if (item?.children && item?.children?.length > 0) {
          if (item.type == 5) {
            const father = findAlias4(newMenus, item.parentId)
            recurve(item.children, father?.children)
          } else {
            recurve(item.children, resetItem.children)
          }
        }
      }
    }
  }
  recurve(reqMenu)
  return newMenus
}

function findAlias4(list: any[], parentId: string) {
  let menuItem: any
  function recurve(arr: any[]) {
    for (const item of arr) {
      if (item.id == parentId) {
        menuItem = item
        return
      }
      if (item.children && item.children.length > 0) {
        recurve(item.children)
      }
    }
  }
  recurve(list)
  return menuItem
}

function resetMenuItem(menuItem: any) {
  if (!firstMenu.value && menuItem) {
    if (menuItem?.type == '1' && menuItem?.chlidren?.[0]?.path) {
      firstMenu.value = menuItem?.chlidren?.[0]
    }

    if (menuItem?.type == '2' && menuItem.path) {
      firstMenu.value = menuItem
    }
  }

  const newItem: any = {
    id: menuItem.id,
    parentId: menuItem.parentId,
    icon: menuItem?.icon,
    path: menuItem?.path,
    name: menuItem?.title,
    type: menuItem?.type,
    meta: { title: menuItem?.title, hidden: menuItem?.isHidden },
    children: []
  }

  return newItem
}
